import React from 'react';
import { InfoPillContainerStyled as InfoPillContainer } from './styles/InfoPillStyled';
import { WarningIcon, DangerIcon, SuccessIcon } from '../../@theme/assets/svg/icons/infoChip';
var InfoPill = function InfoPill(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'danger' : _ref$variant,
    icon = _ref.icon;
  var defaultIconComponent = {
    danger: React.createElement(DangerIcon, null),
    warning: React.createElement(WarningIcon, null),
    success: React.createElement(SuccessIcon, null),
    neutral: null
  }[variant];
  var actualIcon = icon ? icon : defaultIconComponent;
  return React.createElement(InfoPillContainer, {
    className: variant
  }, actualIcon, " ", label);
};
export default InfoPill;